import React from "react";
import {
  Control,
  Controller,
  FieldValues,
  UseFormRegister,
} from "react-hook-form";
import CollapseSection from "../../../collapse/CollapseSection";
import { Grid2, Stack } from "@mui/material";
import TextInput from "../../../input/TextInput";
import { numeralCustom } from "../../../../../utils/helpers";
import NumberInput from "../../../input/NumberInput";
import DateInput from "../../../input/DateInput";

interface IInfoSection {
  register?: UseFormRegister<FieldValues> | undefined;
  control?: Control<any, any>;
}

function VoucherSection({ register, control }: IInfoSection) {
  return (
    <CollapseSection title="Thông tin giảm giá" show>
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Stack gap={2}>
            <Controller
              control={control}
              name="hieu_luc_tu"
              render={({ field: { value, onChange } }) => {
                return (
                  <DateInput
                    label="Hiệu lực từ"
                    labelWidth="30%"
                    value={value}
                    onChange={onChange}
                  />
                );
              }}
            />
            <Controller
              control={control}
              name="hieu_luc_den"
              render={({ field: { value, onChange } }) => {
                return (
                  <DateInput
                    label="Hiệu lực đến"
                    labelWidth="30%"
                    value={value}
                    onChange={onChange}
                  />
                );
              }}
            />
          </Stack>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Stack gap={2}>
            <Controller
              name="so_tien"
              control={control}
              render={({ field: { value, onChange } }) => {
                return (
                  <TextInput
                    label="Tiền giảm"
                    labelWidth="30%"
                    value={numeralCustom(value).format()}
                    onChange={(e) => {
                      const val = numeralCustom(e.target.value).value();
                      onChange(val);
                    }}
                  />
                );
              }}
            />
            <NumberInput
              label="Tỷ lệ giảm"
              labelWidth="30%"
              register={register}
              name="ty_le"
            />
            <Controller
              name="so_tien_max"
              control={control}
              render={({ field: { value, onChange } }) => {
                return (
                  <TextInput
                    label="Tiền giảm tối đa"
                    labelWidth="30%"
                    value={numeralCustom(value).format()}
                    onChange={(e) => {
                      const val = numeralCustom(e.target.value).value();
                      onChange(val);
                    }}
                  />
                );
              }}
            />
          </Stack>
        </Grid2>
      </Grid2>
    </CollapseSection>
  );
}

export default VoucherSection;
